module.exports = __webpack_public_path__ + "img/picture_02.98d22d21.png";